import { call, put } from "redux-saga/effects";
import { actions as deleteGodoActions } from "./slice";
import * as deleteGodoService from "./services";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import i18n from "i18next";
function* fetchDeleteGodoSaga({ payload }) {
const MySwal = withReactContent(Swal);
  try {
    const { data } = yield call(deleteGodoService.postDeleteGodo, payload);
    yield put(deleteGodoActions.fetchDataSuccess(data));
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: "success",
      title:i18n.t("dashboard_delete_godo_popup_title"),
    });
    window.location.reload();
  } catch (err) {
    yield put(deleteGodoActions.fetchDataFailed(err));
  } finally {
    yield put(deleteGodoActions.fetchDataFulfilled());
  }
}

export { fetchDeleteGodoSaga };
